const CITY_TYPES = [
  'locality',
  'postal_town',
  'administrative_area_level_3',
  'administrative_area_level_2',
];

function findComponent(components, types) {
  const match = (components || []).find(component =>
    (component.types || []).some(type => types.includes(type))
  );
  return match ? match.long_name : '';
}

export function formatAddressFromGeocodeResult(result) {
  const components = result?.address_components || [];
  const streetNumber = findComponent(components, ['street_number']);
  const route = findComponent(components, ['route']);
  const street = [route, streetNumber].filter(Boolean).join(' ');
  const city = findComponent(components, CITY_TYPES);
  const country = findComponent(components, ['country']);

  return [street, city, country].filter(Boolean).join(', ');
}

export function geocodeLatLng(lat, lng) {
  return new Promise((resolve, reject) => {
    const geocoder = new window.google.maps.Geocoder();
    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === 'OK' && results && results[0]) {
        resolve(results[0]);
      } else {
        reject(new Error('Geocode error: ' + status));
      }
    });
  });
}
